import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'
import Swal from 'sweetalert2'
import i18next from 'i18next'
const t = (key) => i18next.t(key)

const entity = 'user'

const copyUser = (userId) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/copy_user`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				user_id: userId,
			}),
			successMessage: t('Se copió el usuario correctamente.'),
		})

		// Si quieres mostrar el toast aparte (como en copyTour)
		showSuccessMessage(t('El usuario se copió correctamente'))

		// Si quieres actualizar el store, aquí podrías:
		// dispatch({
		//   type: 'CREATE_USER',
		//   response: res.body.user,
		// })

		return res.body
	}
}


const updateConfiguration = ({ sys_company_module_id, body }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/${entity}/${sys_company_module_id}/update_configuration`,
			{
				method: 'POST',
				body: JSON.stringify(body),
				headers: {
					Authorization: state.app.user.token,
				},
				successMessage: t('Se guardo correctamente la configuración del modelo.'),
			}
		)

		// dispatch(actions.get(unit_id))

		return res.body
	}
}

const updatePermisitions = ({ id, permisitions }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/${id}/permisitions`, {
			method: 'PATCH',
			body: JSON.stringify(permisitions),
			headers: {
				Authorization: state.app.user.token,
			},
			// successMessage: `Se actualizó los permisos correctamente.`,
		})
		dispatch({
			type: `UPDATE_USER`,
			response: res.body,
		})

		return res.body
	}
}

const updatePermissionsSuperAdmin = ({ id, permissions }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/superadmin_update_user_permissions`, {
			method: 'PATCH',
			body: JSON.stringify({ user_id: id, modules_permissions: permissions }),
			headers: {
				token: state.app.superAdmin.token,
			},
			successMessage: t('Se actualizó los permisos correctamente.'),
		})
		dispatch({
			type: `UPDATE_USER`,
			response: res.body,
		})

		return res.body
	}
}

const loadResources = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/wialon/resources`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
			// params: options.params,
		})

		dispatch({
			type: `LOAD_RESOURCES`,
			response: res.body,
		})

		return res.body
	}
}

const importUsers = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/import_users`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: t('Se agreron los usuarios correctamente.'),
		})
		showSuccessMessage(t('Se registraron los usuarios correctamente'))
		return res.body
	}
}

const updateUser = (userData, file) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/user_update/${userData.userId}`, {
			method: 'PATCH',
			json: false,
			body: {
				file: file,
				item: JSON.stringify(userData),
			},
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: t('Se actualizó el usuario correctamente.'),
		})

		dispatch({
			type: `UPDATE_USER`,
			response: res.body,
		})
	}
}

const updateTourSeenRoutesSilent = (userData) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/user_update/${userData.userId}`, {
			method: 'PATCH',
			json: false,
			body: {
				file: null,
				item: JSON.stringify(userData),
			},
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `UPDATE_USER`,
			response: res.body,
		})

		return res.body
	}
}

const updateMultipleRoleUsers = ({ userIds, role_id, sys_company_id }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/bulk_role_user_update`, {
			method: 'PATCH',
			body: JSON.stringify({ userIds, role_id, sys_company_id }),
			headers: {
				Authorization: state.app.user.token,
			},
			// successMessage: `Se actualizaron los roles de los usuarios correctamente.`,
		})

		Swal.fire({
			title: t('¡Acción Realizada!'),
			text: t('Se actualizaron los roles de los usuarios correctamente.'),
			icon: 'success',
			confirmButtonText: t('Ok'),
			showCloseButton: true,
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.reload()
			}
		})

		dispatch({
			type: `UPDATE_MULTIPLE_USERS`,
			response: res.body,
		})
	}
}

const assignMultipleBranchOfficeUsers = ({
	userIds,
	branchOfficeIds,
	sys_company_id,
}) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/bulk_branch_office_user_update`, {
			method: 'PATCH',
			body: JSON.stringify({ userIds, branchOfficeIds, sys_company_id }),
			headers: {
				Authorization: state.app.user.token,
			},
			// successMessage: `Se actualizaron las sucursales de los usuarios correctamente.`,
		})

		Swal.fire({
			title: t('¡Acción Realizada!'),
			text: t('Se actualizaron las sucursales de los usuarios correctamente.'),
			icon: 'success',
			confirmButtonText: t('Ok'),
			showCloseButton: true,
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.reload()
			}
		})

		dispatch({
			type: `UPDATE_MULTIPLE_USERS`,
			response: res.body,
		})
	}
}

const loadUsersByUserType = ({ userType }, id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/get_users_by_usertype`, {
			method: 'GET',
			headers: {
				Authorization: state.app[userType].token,
			},
			params: {
				userType: userType,
				sys_company_id: state.app[userType].sys_company_id,
				id: id,
				[`${userType}_id`]: state.app[userType].id,
			},
		})

		dispatch({
			type: `GET_USERS_BY_USERTYPE`,
			payload: res.body,
		})

		return res.body
	}
}

const getUserPermissions = (userId) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user_permits/${userId}`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body
	}
}

const saveUserPermissions = (permissions, userId) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user_permits/${userId}`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({ permissions }),
		})

		return res.body
	}
}

export const getUsers = () => {
	return async (dispatch, getState) => {
		const state = getState()

		try {
			const res = await callApi(`/user/get_users`, {
				method: 'GET',
				headers: {
					// Authorization: state.app.user.token,
				},
			})

			dispatch({
				type: `GET_USER`,
				payload: res.body,
			})
		} catch (error) {
			showErrorMessage(t('There was a problem fetching users.'), error)
		}
	}
}

const createUserWithImage = (item, files) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/create_user_with_image`, {
			method: 'POST',
			json: false,
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				file: files,
				item: JSON.stringify(item),
			},

			successMessage: t('Se agregó el usuario correctamente'),
			showDefaultAlertError: false,
		})

		if (res.body?.error) {
			showErrorMessage({ error: res.body.error })
		}

		if (res.body && !res.body?.error) {
			dispatch({
				type: 'ADD_USER',
				response: res.body,
			})
		}

		return res.body
	}
}

const updateDefaultDashboard = (default_dashboard) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/${state.app.user.id}/default_dashboard`, {
			method: 'PATCH',
			body: JSON.stringify({ default_dashboard }),
			headers: {
				Authorization: state.app.user.token,
			},
			successMessage: t('Se actualizó el dashboard correctamente.'),
		})

		dispatch({
			type: `UPDATE_USER`,
			response: res.body,
		})
	}
}

const getSysModules = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/utils/get_sys_modules`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body
	}
}

const upsertCustomUserDahboard = (item) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/upsert_custom_user_dashboard`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(item),
		})

		const message = res.body?.message || t('Operación realizada correctamente.')

		Swal.fire({
			title: t('¡Acción Realizada!'),
			text: message,
			icon: 'success',
			confirmButtonText: t('OK'),
			showCloseButton: true,
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.reload()
			}
		})

		return res.body
	}
}

const getCustomUserDashboard = (user_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(
			`/user/utils/get_custom_user_dashboard/${user_id}`,
			{
				method: 'GET',
				headers: {
					Authorization: state.app.user.token,
				},
			}
		)

		return res.body
	}
}

const getAllUsers = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/utils/get_all_users`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body
	}
}

const getCustomLoggedUserDashboard = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/utils/get_custom_logged_user_dashboard`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body
	}
}

const isInitialUser = () => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/is_initial_user`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		return res.body
	}
}

const checkPinUniqueness = (pin, userId, companyId) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/user/check_pin_uniqueness`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				employee_pin: pin,
				user_id: userId || null,
				sys_company_id: companyId,
			}),
		})

		return res.body
	}
}

const getSidebarPinned = (userId) => {
    return async dispatch => {
        const response = await callApi(`/user/${userId}/sidebar_pinned`)
        return response.body
    }
}

const updateSidebarPinned = (userId, sidebar_pinned) => {
    return async dispatch => {
        const response = await callApi(`/user/${userId}/sidebar_pinned`, {
            method: 'PATCH',
            body: { sidebar_pinned }
        })
        return response.body
    }
}

let customActions = {}
customActions = {
	...customActions,
	updateConfiguration,
	updatePermisitions,
	loadResources,
	importUsers,
	updateUser,
	updateTourSeenRoutesSilent,
	updateMultipleRoleUsers,
	assignMultipleBranchOfficeUsers,
	loadUsersByUserType,
	getUserPermissions,
	saveUserPermissions,
	updatePermissionsSuperAdmin,
	createUserWithImage,
	updateDefaultDashboard,
	getSysModules,
	upsertCustomUserDahboard,
	getCustomUserDashboard,
	getAllUsers,
	copyUser,
	getCustomLoggedUserDashboard,
	isInitialUser,
	checkPinUniqueness,
	getSidebarPinned,
	updateSidebarPinned,
}

const actions = {
	...crud('user', 'el usuario', 'los usuarios'),
	...customActions,
}

export default actions
